import z from "zod";

// RV3 type from nb-generative
export const zRV3 = z.object({
	x: z.number(),
	y: z.number(),
	z: z.number(),
});
